<template>
  <div
    class="snack-bar-step-item-container"
  >
    <div
      class="snack-bar-step-item-descriptor"
      v-if="!is_hide_descriptor"
    >
      <TIcon
        class="mr-2"
        :name="$store.state.Ultra.step_icons[step_type.toLowerCase()]"
        color="primary"
      />
      <TText
        :text="step_type + '.' + 'steps'"
        medium
      />
    </div>
    <slot name="above"/>
    <div
      class="snack-bar-step-item-body"
      :style="`background-color: ${getColor(background_color)}`"
    >
      <div class="snack-bar-step-item-body-left">
        <RadialCheckbox
          :is_checked="step.done"
          :foreground_color="foreground_color"
          disabled
        />
        <TText :text="step.text" font_weight="400" max_lines="5" :color="getColor(foreground_color)"/>
      </div>
      <TText v-if="has_offset" :text="`TT ${step.offset}`" :color="getColor(foreground_color)"/>
    </div>
    <slot name="below"/>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';

  export default {

    components: {
      TText,
      TIcon,
      RadialCheckbox,
    },

    props: [
      'step', // is object, contains text and offset
      'step_type', // is string, first letter capitalized e.g. 'Work', 'Design', etc
      'background_color', // is color, contains color of workpackage background
      'foreground_color', // is color, contains color of text
      'is_hide_descriptor', // is boolean, hides descriptor
    ],

    mixins: [
      TColor,
    ],

    computed: {
      has_offset () {
        let type = this.step_type.toLowerCase();
        return type !== 'work' && type !== 'cost' && type !== 'material' && type !== 'machine';
      },
    },

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>
  .snack-bar-step-item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-gap: 8px;
    padding: 6px 0;
  }
  .snack-bar-step-item-descriptor {
    display: flex;
    align-items: center;
  }
  .snack-bar-step-item-body {
    background-color: #888;
    max-width: 420px;
    min-width: 360px;
    padding: 16px 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .snack-bar-step-item-body-left {
    display: flex;
    align-items: center;
    grid-gap: 16px;
  }
</style>
